import React from 'react';
import Register from '../components/Auth/Register';

const RegisterPage = () => <Register />;

export default RegisterPage;